import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  DoctorApiActions,
  ModuleConfigurationActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { Doctor } from "./doctor";

export const featureKey = "doctors";

export type DoctorState = EntityState<Doctor>

export const adapter = createEntityAdapter<Doctor>( {
  selectId: ( doctor: Doctor ) => doctor.id,
  sortComparer: ( a, b ) => a.name.localeCompare( b.name ),
} );

export const initialState: DoctorState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on( ModuleConfigurationActions.loadSuccess, ( state, { moduleConfiguration } ) =>
    adapter.setAll(
      moduleConfiguration.doctors.map( ( d ) => ( {
        name: d.name,
        id: d.id,
        isTxDoctor: d.isTxDoctor,
        practiceLocationId: d.practiceLocationId,
      } ) ),
      state
    )
  )
);
